var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalPriceUsIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z",
    fill: "#F0FDF4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 11.667V28.3337",
    stroke: "#00A63E",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1667 14.167H17.9167C17.1431 14.167 16.4013 14.4743 15.8543 15.0213C15.3073 15.5682 15 16.3101 15 17.0837C15 17.8572 15.3073 18.5991 15.8543 19.1461C16.4013 19.693 17.1431 20.0003 17.9167 20.0003H22.0833C22.8569 20.0003 23.5987 20.3076 24.1457 20.8546C24.6927 21.4016 25 22.1434 25 22.917C25 23.6905 24.6927 24.4324 24.1457 24.9794C23.5987 25.5264 22.8569 25.8337 22.0833 25.8337H15",
    stroke: "#00A63E",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalPriceUsIcon);
export default __webpack_public_path__ + "static/media/total-price-us-icon.ff5c970b83aba719c1b288ca014c3daa.svg";
export { ForwardRef as ReactComponent };